import React, { useEffect, useState } from "react";
import { createAdminLandlord } from "../../api/adminData";

const inputCls =
  "w-full rounded-[8px] border border-black/10 dark:border-white/[0.08] bg-slate-100 dark:bg-[#111520] px-3 py-2 text-sm text-[#0f172a] dark:text-[#eef2ff] outline-none";

export default function CreateLandlordInlineModal({ open, onClose, onSuccess }) {
  const [company_name, setCompany_name] = useState("");
  const [contact_name, setContact_name] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address_line1, setAddress_line1] = useState("");
  const [postal_code, setPostal_code] = useState("");
  const [city, setCity] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setCompany_name("");
    setContact_name("");
    setEmail("");
    setPhone("");
    setAddress_line1("");
    setPostal_code("");
    setCity("");
    setError("");
    setSaving(false);
  }, [open]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    const co = String(company_name || "").trim();
    if (!co) {
      setError("Bitte Firma ausfüllen.");
      return;
    }
    const cn = String(contact_name || "").trim();
    const addr1 = String(address_line1 || "").trim();
    const plz = String(postal_code || "").trim();
    const ort = String(city || "").trim();
    if (!addr1 || !plz || !ort) {
      setError("Bitte Adresse, PLZ und Ort ausfüllen.");
      return;
    }
    const em = String(email || "").trim();
    if (em && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) {
      setError("Bitte eine gültige E-Mail angeben.");
      return;
    }
    setSaving(true);
    try {
      const created = await createAdminLandlord({
        company_name: co,
        contact_name: cn || "—",
        ...(em ? { email: em } : {}),
        phone: String(phone || "").trim() || null,
        address_line1: addr1,
        postal_code: plz,
        city: ort,
        canton: null,
        website: null,
        notes: null,
        status: "active",
      });
      if (onSuccess) onSuccess(created);
      onClose();
    } catch (err) {
      setError(err?.message || "Verwaltung konnte nicht erstellt werden.");
    } finally {
      setSaving(false);
    }
  }

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4 dark:bg-black/60"
      onClick={(e) => {
        if (e.target === e.currentTarget && !saving) onClose();
      }}
    >
      <div
        className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-[14px] border border-black/10 bg-white p-5 dark:border-white/[0.07] dark:bg-[#141824]"
        onClick={(e) => e.stopPropagation()}
      >
        <h4 className="m-0 text-base font-semibold text-[#0f172a] dark:text-[#eef2ff]">Neue Verwaltung</h4>
        <p className="mt-1 mb-4 text-[11px] text-[#64748b] dark:text-[#93a4bf]">
          Wird in der Verwaltungsliste gespeichert und hier ausgewählt.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Firma *</label>
            <input className={inputCls} value={company_name} onChange={(e) => setCompany_name(e.target.value)} />
          </div>
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Kontaktperson (optional)</label>
            <input className={inputCls} value={contact_name} onChange={(e) => setContact_name(e.target.value)} />
          </div>
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">E-Mail (optional)</label>
            <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Telefon (optional)</label>
            <input className={inputCls} value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Adresse *</label>
            <input className={inputCls} value={address_line1} onChange={(e) => setAddress_line1(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">PLZ *</label>
              <input className={inputCls} value={postal_code} onChange={(e) => setPostal_code(e.target.value)} />
            </div>
            <div>
              <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Ort *</label>
              <input className={inputCls} value={city} onChange={(e) => setCity(e.target.value)} />
            </div>
          </div>
          {error ? <p className="m-0 text-sm text-[#f87171]">{error}</p> : null}
          <div className="mt-2 flex justify-end gap-2">
            <button
              type="button"
              disabled={saving}
              onClick={onClose}
              className="rounded-lg border border-black/10 px-3 py-2 text-sm dark:border-white/[0.12]"
            >
              Abbrechen
            </button>
            <button
              type="submit"
              disabled={saving}
              className="rounded-lg bg-[#5b8cff] px-3 py-2 text-sm font-semibold text-white disabled:opacity-50"
            >
              {saving ? "…" : "Anlegen"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
